const isNumber = value => value >= 0 && value <= 24 && (value * 4) % 1 === 0;
export default isNumber;
